<div class="login-page">
    <header>
        <div class="customer-language-picker-area">
            <div class="picker-label">
                <label class="switch">
                    <input
                        type="checkbox"
                        (change)="useLang($event.target.checked ? 'en' : 'da')"
                        [checked]="currentLang === 'en'"
                    />
                    <span class="slider round">
                        <span class="lang lang-da">Dansk</span>
                        <span class="slider-color"></span>
                        <span class="lang lang-en">English</span>
                    </span>
                </label>
            </div>
        </div>
    </header>
    <section class="login-page__body">
        <div class="login-page__center">
            <div class="login-page__panel">
                <div class="login-page__panel-header">
                    <a href="/" class="login-page__logo">
                        <img src="assets/images/Pitten.svg" alt="PITTEN" />
                    </a>
                </div>
                <div class="login-page__panel-body">
                    <p class="login-page__title">
                        {{ "manual.welcome" | translate }}
                    </p>
                    <p class="login-page__subtitle">
                        {{ "loginPage.loginTag" | translate }}
                    </p>

                    <form
                        id="loginForm"
                        [formGroup]="loginForm"
                        (ngSubmit)="onSubmit()"
                        class="login-page__form"
                    >
                        <div
                            class="login-page__form-group"
                            [hidden]="displayTwoFactor"
                        >
                            <div>
                                <input
                                    formControlName="email"
                                    type="text"
                                    class="login-page__input"
                                    placeholder="E-mail"
                                />
                            </div>
                        </div>
                        <div [hidden]="displayTwoFactor">
                            <div>
                                <input
                                    formControlName="password"
                                    type="password"
                                    class="login-page__input"
                                    placeholder="Password"
                                />
                            </div>
                            <div class="mt-1">
                                <a
                                    routerLink="/forgot-password"
                                    class="login-link-text"
                                    >{{ "loginPage.forgotPw" | translate }}</a
                                >
                            </div>
                        </div>


                        <div
                            class="login-page__form-group"
                            [hidden]="!displayTwoFactor"
                        >
                            <label class="login-page__label"
                                >Two-Factor Authentication code</label
                            >
                            <div
                                class="login-page__input-group login-page__two-factor"
                            >
                                <input
                                    formControlName="twoFactorCode"
                                    type="text"
                                    class="login-page__input"
                                />
                                <span class="login-page__input-icon"
                                    ><i class="fa fa-lock"></i
                                ></span>
                            </div>
                        </div>

                        <div class="login-page__action">
                            <app-input-button>{{
                                "loginPage.login" | translate
                            }}</app-input-button>
                        </div>

                        <p class="login-link-text">
                            {{ "loginPage.ifUser?" | translate
                            }}<a
                                routerLink="/create-profile"
                                class="ml-2"
                                >{{ "loginPage.signUp" | translate }}</a
                            >
                        </p>
                        <div class="d-flex justify-content-between">
                            <div>
                                <a
                                    class="login-link-text"
                                    href="https://kollab.dk/freelance-privatperson/"
                                    target="_blank"
                                    >{{
                                        "loginPage.moreAboutKollab" | translate
                                    }}</a
                                >
                            </div>
                            <div>
                                <a
                                    class="login-link-text"
                                    href="/assets/Privatlivspolitik_til_PITTEN_072025.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    >{{
                                        "labels.dataAndPrivacy" | translate
                                    }}</a
                                >
                            </div>
                        </div>
                    </form>
                </div>

                <!-- </div> -->
            </div>
        </div>
    </section>
</div>

<div class="login-page__background"></div>
